import { createContext, type JSX, type ReactNode, useContext } from 'react';

import type { AnalyticsReadPort } from './AnalyticsReadPort.js';

const AnalyticsReadContext = createContext<AnalyticsReadPort | null>(null);

/** Supplies the admin analytics reader at the composition boundary. */
export function AnalyticsReadProvider({
  port,
  children,
}: {
  readonly port: AnalyticsReadPort;
  readonly children: ReactNode;
}): JSX.Element {
  return <AnalyticsReadContext.Provider value={port}>{children}</AnalyticsReadContext.Provider>;
}

/** Resolves the required analytics reader; no demo or mock fallback exists in production. */
export function useAnalyticsReadPort(): AnalyticsReadPort {
  const port = useContext(AnalyticsReadContext);
  if (port === null) {
    throw new Error('useAnalyticsReadPort must be used within an AnalyticsReadProvider');
  }
  return port;
}
